<mat-toolbar class="main-header">
  @if (sidenav.mode === "over") {
    <button mat-icon-button (click)="toggleMenu()">
      @if (!sidenav.opened) {
        <mat-icon> menu </mat-icon>
      }
      @if (sidenav.opened) {
        <mat-icon> close </mat-icon>
      }
    </button>
  }
  @if (isAdminView) {
    <button mat-icon-button (click)="goBack()" class="back-btn">
      <mat-icon>arrow_back</mat-icon>
    </button>
  }
  <span>{{ pageTitle }}</span>
</mat-toolbar>

<div class="profile-page">
  <section class="profile-hero">
    <div class="hero-backdrop"></div>
    <div class="hero-content">
      <div class="avatar-stack">
        <div class="avatar-frame">
          <app-avatar [user]="user"></app-avatar>
        </div>
        <label class="avatar-action" for="profileAvatarInput">
          <mat-icon>photo_camera</mat-icon>
          Cambiar foto
        </label>
        <input
          id="profileAvatarInput"
          type="file"
          accept="image/*"
          (change)="fileBrowseHandler($event)"
        />
      </div>

      <div class="hero-copy">
        <h1>{{ user?.name || "Tu perfil" }}</h1>
        <p>{{ user?.email }}</p>
      </div>
    </div>
  </section>

  <section class="profile-card">
    <h2>Datos de la cuenta</h2>

    <mat-form-field appearance="outline">
      <mat-label>Nombre</mat-label>
      <input matInput type="text" [(ngModel)]="user.name" required />
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Email</mat-label>
      <input matInput type="email" [(ngModel)]="user.email" required />
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>WhatsApp</mat-label>
      <input
        matInput
        type="tel"
        inputmode="tel"
        autocomplete="tel"
        placeholder="+34 600 000 000"
        [(ngModel)]="user.phoneNumber"
      />
      <mat-hint
        >Lo usaremos para recordatorios de rondas y otras notificaciones
        importantes.</mat-hint
      >
    </mat-form-field>

    <div class="password-hint">
      <mat-icon>info</mat-icon>
      <span>
        Si no quieres cambiar la contraseña, deja los campos de contraseña
        vacíos.
      </span>
    </div>

    @if (!isAdminView) {
      <mat-form-field appearance="outline">
        <mat-label>Contraseña actual</mat-label>
        <input
          matInput
          [type]="hideCurrentPassword ? 'password' : 'text'"
          [(ngModel)]="currentPassword"
        />
        <button
          mat-icon-button
          matSuffix
          type="button"
          [attr.aria-label]="
            hideCurrentPassword
              ? 'Mostrar contraseña actual'
              : 'Ocultar contraseña actual'
          "
          [attr.aria-pressed]="!hideCurrentPassword"
          (click)="hideCurrentPassword = !hideCurrentPassword"
        >
          <mat-icon>{{
            hideCurrentPassword ? "visibility" : "visibility_off"
          }}</mat-icon>
        </button>
      </mat-form-field>
    }

    <mat-form-field appearance="outline">
      <mat-label>Nueva contraseña</mat-label>
      <input
        matInput
        [type]="hideNewPassword ? 'password' : 'text'"
        [(ngModel)]="newPassword"
      />
      <button
        mat-icon-button
        matSuffix
        type="button"
        [attr.aria-label]="
          hideNewPassword
            ? 'Mostrar nueva contraseña'
            : 'Ocultar nueva contraseña'
        "
        [attr.aria-pressed]="!hideNewPassword"
        (click)="hideNewPassword = !hideNewPassword"
      >
        <mat-icon>{{
          hideNewPassword ? "visibility" : "visibility_off"
        }}</mat-icon>
      </button>
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Confirmar nueva contraseña</mat-label>
      <input
        matInput
        [type]="hideConfirmPassword ? 'password' : 'text'"
        [(ngModel)]="confirmPassword"
      />
      <button
        mat-icon-button
        matSuffix
        type="button"
        [attr.aria-label]="
          hideConfirmPassword
            ? 'Mostrar confirmación de contraseña'
            : 'Ocultar confirmación de contraseña'
        "
        [attr.aria-pressed]="!hideConfirmPassword"
        (click)="hideConfirmPassword = !hideConfirmPassword"
      >
        <mat-icon>{{
          hideConfirmPassword ? "visibility" : "visibility_off"
        }}</mat-icon>
      </button>
    </mat-form-field>

    <button mat-flat-button color="primary" class="save-btn" (click)="update()">
      Guardar cambios
    </button>
  </section>

  @if (!isAdminView) {
    <section class="profile-card">
      <h2>Notificaciones</h2>

      <div class="setting-row">
        <div class="setting-copy">
          <strong>Notificaciones push</strong>
          <p>Recibe avisos importantes de la porra en este dispositivo.</p>
        </div>

        <button
          mat-stroked-button
          color="primary"
          class="notifications-btn"
          [disabled]="!notificationsSupported"
          (click)="toggleNotifications()"
        >
          <mat-icon>notifications</mat-icon>
          @if (notificationsEnabled) {
            Desactivar
          } @else {
            Activar
          }
        </button>
      </div>

      @if (!notificationsSupported) {
        <div class="settings-hint">
          <mat-icon>info</mat-icon>
          <span>Este dispositivo o navegador no soporta notificaciones.</span>
        </div>
      } @else {
        <div class="settings-hint">
          <mat-icon>{{
            notificationsEnabled ? "check_circle" : "notifications_off"
          }}</mat-icon>
          <span>
            @if (notificationsEnabled) {
              Las notificaciones están activadas.
            } @else {
              Las notificaciones están desactivadas.
            }
          </span>
        </div>
      }
    </section>
  }
</div>

<block-ui></block-ui>
